import type { UseMutationConfig } from 'react-relay';
import type {
  Disposable,
  MutationParameters,
  PayloadError,
} from 'relay-runtime';

type RelayMutationResult<TMutation extends MutationParameters> = {
  response: TMutation['response'];
  /** GraphQL field errors, which Relay delivers alongside the payload. */
  errors: readonly PayloadError[];
};

/** Rejects only on network or transport errors (`onError`). */
export const relayMutationToPromise = <TMutation extends MutationParameters>(
  mutation: (config: UseMutationConfig<TMutation>) => Disposable,
  config: Omit<UseMutationConfig<TMutation>, 'onCompleted' | 'onError'>,
): Promise<RelayMutationResult<TMutation>> => {
  return new Promise((resolve, reject) => {
    mutation({
      ...config,
      onCompleted: (response, errors) => {
        resolve({ response, errors: errors ?? [] });
      },
      onError: (error) => {
        reject(error);
      },
    });
  });
};
